$(document).ready(function () {
  // footer js
  $('.footer-block--menu, .footer-block--brand').wrapAll('<div class="article_main-slider"></div>');
  //footer js
  
   $('body').on('click','.button___image_thumb',function(){
    var index = parseInt($('button.thumbnail[aria-current="true"]').parent().attr('data-media-position'));
    if($(this).hasClass('arrow_prev')){
      index--;
  if(index > 0){
    $(`[data-media-position="${index}"] button`).trigger('click');
  }
    }else{
       index++; 
       $(`[data-media-position="${index}"] button`).trigger('click');
    }
  });
  
 //-------Adding products to Ushop Canada checkout code starts------//
  $('body').on('click','[name="checkout"]',function(){
         var add_vairiants ='&';
         var ids ='';
        $('.cart__drawer__meta').each(function(){
        var val = $(this).attr('data-id');
        var qty =  $(this).find('.quantity__input').val(); 
          ids =ids+'updates%5B'+val+'%5D='+qty+''+add_vairiants;
        }).promise().done(function(){
        var lastindex = ids.lastIndexOf('&');
        ids= ids.substr(0,lastindex);
       var url ='https://theushop.ca/checkout?'+ids;
      // console.log(url);
          window.location.href=url;
      });
    })
});